import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const PaymentContext = createContext()

const PaymentProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllPayments = async (currentPage, rowsPerPage, sortField, sortOrder, filter) => {
        try {
            const { data } = await axios.get(`${baseURL}/payment/list?&sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&restaurant_id=${restaurantId}&filter=${filter !== '' ? filter : null}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Payment', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSinglePayment = async (id) => {
        try {
            let response = await axios.get(`${baseURL}/payment/single-payment/${id}`, { headers })
            if (response.data.error === false) {
                return response.data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Payment', detail: response?.data?.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Payment', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createPayment = async (paymentDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/payment/create`, paymentDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Payment', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Payment', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Payment', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Payment', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Payment', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updatePayment = async (id, paymentDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/payment/update/${id}`, paymentDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Payment', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Payment', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Payment', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Payment', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Payment', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deletePayment = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/payment/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Payment', detail: data.message, life: 3000 })
            } else {
                toast.current?.show({ severity: 'error', summary: 'Payment', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Payment', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <PaymentContext.Provider value={{ getAllPayments, getSinglePayment, createPayment, updatePayment, deletePayment }}>
            {children}
        </PaymentContext.Provider>
    )
}

const usePayment = () => useContext(PaymentContext)

export { usePayment, PaymentProvider }